import type contentEn from "./content.en";

const contentAr: Record<keyof typeof contentEn, string> = {
  "common.edit": "تعديل",
  "common.select_all": "تحديد الكل",
  "nav.pages": "الصفحات",
  "nav.preferences": "التفضيلات",
  "nav.menus": "قوائم التنقل",
  "nav.blog_posts": "المدونة",
  "nav.form_submissions": "الرسائل",

  "vis.title": "الظهور",
  "vis.visible": "ظاهر",
  "vis.hidden": "مخفي",
  "vis.scheduled": "مجدول",
  "vis.set_date": "تحديد تاريخ الظهور",
  "vis.publish_on": "يظهر في {date}",
  "vis.clear_date": "مسح التاريخ",
  "vis.visible_since": "ظاهر منذ {date}",

  "template.title": "قالب السمة",
  "template.default": "{type} الافتراضي",
  "template.custom_page": "صفحة مخصصة: {name}",
  "template.custom_page_hint": "الصفحات المخصصة ملفات Liquid في مجلد custom_pages في السمة.",

  "pages.title": "الصفحات",
  "pages.add": "إضافة صفحة",
  "pages.empty_title": "أضف صفحات إلى واجهة متجرك",
  "pages.empty_body": "اكتب عناوين وأوصافاً واضحة للصفحات لتحسين ظهورك في محركات البحث ومساعدة العملاء في العثور على موقعك.",
  "pages.col.title": "العنوان",
  "pages.col.updated": "آخر تحديث",
  "pages.filter.all": "الكل",
  "pages.filter.visible": "ظاهرة",
  "pages.filter.hidden": "مخفية",
  "pages.selected": "تم تحديد {count}",
  "pages.show": "إظهار",
  "pages.hide": "إخفاء",
  "pages.delete": "حذف الصفحات",
  "pages.delete_confirm": "حذف {count} صفحة؟",
  "pages.delete_body": "لا يمكن استعادة الصفحات المحذوفة. ستعرض روابطها «الصفحة غير موجودة».",
  "pages.content": "المحتوى",
  "pages.view": "عرض الصفحة",
  "pages.handle_hint": "تغيير الرابط ينشئ تحويلاً من الرابط القديم.",
  "pages.seo_preview": "الظهور في محركات البحث",
  "pages.seo_hint": "أضف عنواناً ووصفاً لترى كيف قد تظهر هذه الصفحة في نتائج البحث.",
  "pages.seo_title_count": "{count} من 70 حرفاً",
  "pages.seo_description_count": "{count} من 160 حرفاً",
  "pages.not_found": "هذه الصفحة غير موجودة أو حُذفت.",

  "blog.title": "مقالات المدونة",
  "blog.add": "إضافة مقال",
  "blog.manage": "إدارة المدونات",
  "blog.comments_link": "التعليقات",
  "blog.empty_title": "اكتب مقالاً",
  "blog.empty_body": "المقالات طريقة رائعة لبناء مجتمع حول منتجاتك وعلامتك التجارية.",
  "blog.col.title": "العنوان",
  "blog.col.blog": "المدونة",
  "blog.col.author": "الكاتب",
  "blog.col.updated": "آخر تحديث",
  "blog.all_blogs": "كل المدونات",
  "blog.excerpt": "المقتطف",
  "blog.excerpt_hint": "أضف ملخصاً للمقال يظهر في الصفحة الرئيسية أو المدونة.",
  "blog.organization": "التنظيم",
  "blog.author": "الكاتب",
  "blog.blog": "المدونة",
  "blog.tags": "الوسوم",
  "blog.image": "الصورة",
  "blog.image_alt": "النص البديل للصورة",
  "blog.delete": "حذف المقال",
  "blog.delete_confirm": "حذف {title}؟",
  "blog.delete_many": "حذف {count} مقال؟",
  "blog.need_blog": "أنشئ مدونة أولاً.",
  "blog.new_blog": "مدونة جديدة",
  "blog.blog_title": "عنوان المدونة",
  "blog.comments": "التعليقات",
  "blog.comments.disabled": "التعليقات معطلة",
  "blog.comments.moderated": "التعليقات مسموحة بعد المراجعة",
  "blog.comments.auto_published": "التعليقات مسموحة وتُنشر تلقائياً",
  "blog.delete_blog": "حذف المدونة",
  "blog.delete_blog_confirm": "حذف {title} و{count} مقال فيها؟",
  "blog.posts_count": "{count} مقال",

  "comments.title": "التعليقات",
  "comments.pending": "بانتظار المراجعة",
  "comments.published": "منشورة",
  "comments.spam": "مزعجة",
  "comments.removed": "محذوفة",
  "comments.empty": "لا توجد تعليقات هنا.",
  "comments.on": "على {title}",
  "comments.approve": "نشر",
  "comments.mark_spam": "مزعج",
  "comments.not_spam": "ليس مزعجاً",
  "comments.remove": "حذف",

  "menus.title": "القوائم",
  "menus.add": "إنشاء قائمة",
  "menus.redirects": "عرض تحويلات الروابط",
  "menus.col.title": "العنوان",
  "menus.col.items": "عناصر القائمة",
  "menus.name": "الاسم",
  "menus.handle": "المعرّف",
  "menus.handle_hint": "تستخدم السمات المعرّف للعثور على القائمة.",
  "menus.items": "عناصر القائمة",
  "menus.add_item": "إضافة عنصر",
  "menus.empty_items": "لا توجد عناصر في هذه القائمة.",
  "menus.item_title": "التسمية",
  "menus.item_link": "الرابط",
  "menus.edit_item": "تعديل العنصر",
  "menus.add_child": "إضافة عنصر تحت {title}",
  "menus.missing": "العنصر المرتبط محذوف",
  "menus.delete": "حذف القائمة",
  "menus.delete_confirm": "حذف {title}؟",
  "menus.protected": "لا يمكن حذف القائمة الرئيسية وقائمة التذييل.",
  "menus.move_up": "تحريك لأعلى",
  "menus.move_down": "تحريك لأسفل",
  "menus.indent": "وضعه تحت العنصر السابق",
  "menus.outdent": "نقله مستوى للخارج",
  "menus.depth_hint": "يمكن أن تصل القوائم إلى 3 مستويات.",
  "link.search": "ابحث أو الصق رابطاً",
  "link.type.home": "الصفحة الرئيسية",
  "link.type.catalog": "كل المنتجات",
  "link.type.collections": "كل المجموعات",
  "link.type.search": "صفحة البحث",
  "link.type.product": "المنتجات",
  "link.type.collection": "المجموعات",
  "link.type.page": "الصفحات",
  "link.type.blog": "المدونات",
  "link.type.article": "المقالات",
  "link.type.policy": "السياسات",
  "link.type.custom_page": "الصفحات المخصصة",
  "link.type.url": "عنوان ويب",
  "link.none": "لا توجد نتائج",
  "link.back": "رجوع",
  "link.choose": "اختر رابطاً",

  "redirects.title": "تحويلات الروابط",
  "redirects.add": "إنشاء تحويل",
  "redirects.import": "استيراد",
  "redirects.export": "تصدير",
  "redirects.empty_title": "أدر تحويلات روابط متجرك",
  "redirects.empty_body": "عند تغيير رابط، وجّه الزوار الذين يستخدمون الرابط القديم إلى الصفحة الجديدة.",
  "redirects.from": "التحويل من",
  "redirects.to": "التحويل إلى",
  "redirects.from_hint": "مثال: ‎/old-page",
  "redirects.to_hint": "مثال: ‎/new-page أو رابط https://‎ كامل",
  "redirects.force": "التحويل حتى لو وُجدت صفحة على هذا الرابط",
  "redirects.temporary": "تحويل مؤقت (302)",
  "redirects.auto": "تلقائي",
  "redirects.delete": "حذف التحويلات",
  "redirects.delete_confirm": "حذف {count} تحويل؟",
  "redirects.import_title": "استيراد التحويلات من ملف CSV",
  "redirects.import_hint": "يحتوي الملف على عمودين: «Redirect from» و«Redirect to». حتى 20,000 صف.",
  "redirects.import_done": "تم استيراد {count} تحويل",
  "redirects.import_errors": "لم تُستورد هذه الصفوف:",
  "redirects.row": "الصف {row}",
  "redirects.sample": "تنزيل ملف CSV نموذجي",
  "redirects.choose_file": "اختيار ملف",

  "policies.title": "السياسات",
  "policies.hint": "تظهر روابط السياسات في تذييل صفحة الدفع ويمكن إضافتها إلى قوائم متجرك.",
  "policies.notice": "صيغت هذه السياسات من بيانات متجرك. راجعها قبل الإطلاق، فهي ليست استشارة قانونية.",
  "policies.settings_hint": "سياسات الاسترداد والخصوصية والشروط وغيرها",
  "policies.view": "عرض",
  "policies.empty": "بلا محتوى: السياسة مخفية في متجرك.",

  "prefs.title": "التفضيلات",
  "prefs.seo": "العنوان والوصف",
  "prefs.seo_hint": "يساعد العنوان والوصف في تحديد طريقة ظهور متجرك في محركات البحث.",
  "prefs.home_title": "عنوان الصفحة الرئيسية",
  "prefs.home_description": "الوصف",
  "prefs.share_image": "صورة المشاركة",
  "prefs.share_image_hint": "عند مشاركة رابط متجرك على وسائل التواصل تظهر صورة عادةً. يُنصح بمقاس 1200 × 628 بكسل.",
  "prefs.add_image": "إضافة صورة",
  "prefs.password": "الحماية بكلمة مرور",
  "prefs.password_hint": "قصر الدخول على الزوار الذين لديهم كلمة المرور.",
  "prefs.password_enabled": "تقييد الدخول بكلمة مرور",
  "prefs.password_field": "كلمة المرور",
  "prefs.password_set": "تم تعيين كلمة مرور. أدخل كلمة جديدة لتغييرها.",
  "prefs.password_message": "رسالة للزوار",
  "prefs.launch_note": "متجرك محمي بكلمة مرور حتى تطلقه. أزلها من الإعدادات > حالة المتجر.",
  "prefs.spam": "الحماية من الرسائل المزعجة",
  "prefs.spam_hint": "تصفية الرسائل المزعجة المحتملة من نماذج التواصل وتعليقات المدونة.",
  "prefs.spam_enabled": "تصفية الرسائل المزعجة في نماذج التواصل والتعليقات",
  "prefs.blocked": "الدول المحظورة",
  "prefs.blocked_hint": "يرى الزوار من هذه الدول إشعاراً بدلاً من متجرك.",
  "prefs.add_country": "إضافة دولة",

  "forms.title": "رسائل النماذج",
  "forms.inbox": "الوارد",
  "forms.spam": "المزعجة",
  "forms.empty_title": "لا توجد رسائل بعد",
  "forms.empty_body": "تظهر هنا رسائل نموذج التواصل، وتُرسل أيضاً إلى بريد التواصل الخاص بمتجرك.",
  "forms.mark_read": "تعيين كمقروءة",
  "forms.mark_unread": "تعيين كغير مقروءة",
  "forms.delete": "حذف",
  "forms.delete_confirm": "حذف {count} رسالة؟",
  "forms.export": "تصدير",
  "forms.from_page": "أُرسلت من {page}",
  "forms.unread": "{count} غير مقروءة",
  "forms.phone": "الهاتف",
  "forms.reply": "رد",
};

export default contentAr;
